<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              ref="ref"
              type="text"
              name="tracking_code"
              label="شناسه ارجاع"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.tracking_code"
            />
            <bita-input
              ref="tracking"
              type="text"
              name="ref_id"
              label="آتوریتی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.ref_id"
            />
          </div>
        </div>
      </bita-form>
      <div
        slot="footer"
        class="d-flex flex-column flex-md-row k-gap-3 justify-content-between"
      >
        <div class="col-12 col-md-2" v-if="!propsData.id">
          <bita-bootbutton
            type="primary"
            title="ذخیره"
            class="w-100"
            icon="fa fa-check"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-2 px-md-5">
          <bita-bootbutton
            class="w-100 bg-transparent border-0 text-danger"
            type="danger"
            title="بستن"
            icon="fas fa-times"
            data-dismiss="modal"
            @click.native="
              () => {
                $emit('change-status-modal');
              }
            "
          />
        </div>
      </div>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    propsData: {
      type: Object,
      default: {
        tracking_code: "",
        ref_id: "",
      },
    },
    propsPermissions: {},
  },
  data() {
    return {
      colWidth: "col-lg-4",
      allPermissions: [],
      form: {},
    };
  },
  watch: {
    propsData: function(_data) {
      this.form = _data;
    },
    propsPermissions: function(_data) {
      this.allPermissions = _data;
    },
  },
  methods: {
    toggleLoading() {
      this.$emit("isLoading");
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.form);
        }
      });
    },
    onCloseModal() {
      let refs = ["ref", "tracking"];
      for (let ref of refs) {
        if (this.$refs[ref]) this.$refs[ref].emptyKendo();
      }
      this.$refs.form.reset();
    },
  },
};
</script>
